import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { buttonClass, type ButtonSize, type ButtonVariant } from "./Button";

/** Router-aware button-styled link (`ButtonLink` is a plain `<a href>`, which reloads the app). */
export function LinkButton({ to, variant = "secondary", size = "md", className, icon, children, ...rest }: { to: string; variant?: ButtonVariant; size?: ButtonSize; className?: string; icon?: ReactNode; children: ReactNode; onClick?: (e: React.MouseEvent) => void; "aria-label"?: string }) {
  return <Link to={to} className={clsx(buttonClass(variant, size, className), "no-underline")} {...rest}>{icon}{children}</Link>;
}
